/* export const websiteUrl = 'http://192.168.1.39:10000';
export const webAddress = '192.168.1.39:10000'; */
/* export const websiteUrl = 'http://10.2.144.138:8081/api';
export const webAddress = '10.2.144.138:8081/api'; */
// export const websiteUrl = 'http://192.168.1.123:8880';
// export const webAddress = '192.168.1.123:8880';
// // 图片服务器
// export const fileUrl = 'http://192.168.1.117:9000';

export const websiteUrl = 'https://www.xinhua-tech.com.cn/back';
export const webAddress = 'www.xinhua-tech.com.cn/back';
// 图片服务器
export const fileUrl = 'https://www.xinhua-tech.com.cn/minio';



//////////////////
// WEBPACK FOOTER
// ./url.js
// module id = 41K4
// module chunks = 19